<template>
  <Card>
    <Button type="primary" class="public-fr" icon="ios-undo" @click="back"
      >返回</Button
    >
    <table style="margin-top: 40px">
      <tr>
        <th colspan="7">物料信息</th>
      </tr>
      <tr>
        <th>物料名称</th>
        <td>{{ detail.name }}</td>
        <th>物料渠道</th>
        <td>{{ detail.channelCode }}</td>
        <th>物料品牌</th>
        <td>{{detail.a}}</td>
      </tr>
      <tr>
        <th>批次号</th>
        <td>{{detail.a}}</td>
        <th>二维码尺寸</th>
        <td>{{detail.a}}</td>
        <th>二维码基础编码</th>
        <td>{{detail.a}}</td>
      </tr>
      <tr>
        <th>物料状态</th>
        <td>{{detail.a}}</td>
        <th>生效日期</th>
        <td>{{detail.a}}</td>
        <th>失效日期</th>
        <td>{{detail.a}}</td>
      </tr>
      <tr>
        <th>门店等级</th>
        <td>{{detail.a}}</td>
        <th>达e购ID</th>
        <td>{{detail.a}}</td>
        <th>达能系统门店码</th>
        <td>{{detail.a}}</td>
      </tr>
      <tr>
        <th>大区</th>
        <td>{{ detail.bgRpName }}</td>
        <th>省份</th>
        <td>{{ detail.provinceName }}</td>
        <th>城市</th>
        <td>{{ detail.cityName }}</td>
      </tr>
      <tr>
        <th>人员编码</th>
        <td>{{ detail.srId }}</td>
        <th>角色</th>
        <td>{{ detail.roleType }}</td>
        <th></th>
        <td></td>
      </tr>
    </table>
    <table style="margin-top: 40px">
      <tr>
        <th colspan="7">激活信息</th>
      </tr>
      <tr>
        <th>二维码编码</th>
        <td>{{ detail.qrCode }}</td>
        <th>门店名称</th>
        <td>{{ detail.retName }}</td>
        <th>门店渠道</th>
        <td>{{ detail.retailerChannelCode }}</td>
      </tr>
      <tr>
        <th>激活状态</th>
        <td>{{ detail.status }}</td>
        <th>是否已校验</th>
        <td>{{ detail.isConfirm }}</td>
        <th>扫码次数</th>
        <td>{{ detail.scanNum }}</td>
      </tr>
      <tr>
        <th>激活经度</th>
        <td>{{ detail.jhLongitude }}</td>
        <th>激活纬度</th>
        <td>{{ detail.jhLatitude }}</td>
        <th></th>
        <td></td>
      </tr>
    </table>
    <table style="margin-top: 40px">
      <tr>
        <th colspan="7">校验信息</th>
      </tr>
      <tr>
        <th>校验二维码编码</th>
        <td>{{ detail.qrCode }}</td>
        <th>门店名称</th>
        <td>{{ detail.retName }}</td>
        <th>门店渠道</th>
        <td>{{ detail.retailerChannelCode }}</td>
      </tr>
      <tr>
        <th>扫码时间</th>
        <td>{{ detail.scanTime }}</td>
        <th>校验人</th>
        <td>{{ detail.srName }}</td>
        <th>校验人角色</th>
        <td>{{ detail.roleType }}</td>
      </tr>
      <tr>
        <th>经度</th>
        <td>{{ detail.longitude }}</td>
        <th>纬度</th>
        <td>{{ detail.latitude }}</td>
        <th>校验结果</th>
        <td>{{ detail.state | showState }}</td>
      </tr>
    </table>
  </Card>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
    };
  },
  filters: {
    showState(state) {
      let t = "";
      switch ("" + state) {
        case "0":
          t = "正常";
          break;
        case "1":
          t = "未激活";
          break;
        case "2":
          t = "失效";
          break;
        case "3":
          t = "店码不符";
          break;
        case "4":
          t = "不在发放清单中";
          break;
        case "5":
          t = "物码不符";
          break;
        default:
          t = "";
      }
      return t;
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      let data = this.$route.query;
      this.$api.scanDetail(data).then((res) => {
        if (res.code == "200") {
          this.detail = res.data;
        }
      });
    },
    back() {
      this.$router.push({
        path: "scanList",
      });
    },
  },
};
</script>
<style scoped>
table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
}

th,
td {
  padding: 0 10px;
  text-align: center;
  border: 1px solid #dcdee2;
  line-height: 30px;
  color: #515a6e;
  font-size: 12px;
}

th {
  background: #f8f8f9;
}
</style>


// WEBPACK FOOTER //
// src/views/material/scanDetail.vue